import { useSelector } from "react-redux";

export const useCustomer = () => {
  const { customer } = useSelector(({ customerState: { customer } }) => ({
    customer
  }));
  return customer;
};
